import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import { getMesAno } from "app/Core/Helpers";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    noBorder: {
        borderBottom: "0px"
    },
    bgLineHeader: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#666"
    },
    bgLineDetails: {
        backgroundColor: theme.palette.type === "dark" ? "#666" : "#F2F2F2"
    },
    colorHeader: {
        color: "#CCC"
    }
});

class TarefaApontamentoList extends XAPPComponent {

    getApontamentos = () => {
        var AResponse = [];
        const { apontamentos = null, natureza } = this.props;

        if (!_.isNull(apontamentos)) {
            apontamentos.forEach(item => {
                if (([20].includes(natureza) && item.natureza === 4) || item.natureza === natureza) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    };

    getColumnsItens = () => {
        var AResponse = [];
        const { natureza, sistemas, xappRouteParams } = this.props;
        const ATipos = sistemas[xappRouteParams.empresa]?.tipos ?? "[]";
        const Columns = [
            {
                Header: "ID",
                accessor: "idtarefaprocessoapontamentoitem",
                align: "center",
                natureza: [0, 1, 2, 3, 4, 5, 6, 7, 18]
            },
            {
                Header: "Nome",
                accessor: "nome",
                align: "start",
                className: "w-360",
                natureza: [0, 1, 3, 4, 7, 18, 20]
            },
            {
                Header: "Qtd",
                accessor: "quantidade",
                align: "center",
                natureza: [0, 1, 3, 4, 7, 18, 20]
            },
            {
                Header: "Valor",
                accessor: "valordescricao",
                align: "center",
                natureza: [0, 1, 3, 4, 7, 18]
            },
            {
                Header: "Desconto",
                accessor: "descontodescricao",
                align: "center",
                natureza: [0, 1, 3, 4, 7, 18]
            },
            {
                Header: "Valor total",
                accessor: "valortotaldescricao",
                align: "center",
                natureza: [0, 1, 3, 4, 7, 18]
            },
            {
                Header: "Total realizado",
                accessor: "quantidaderealizado",
                align: "center",
                natureza: [20]
            },
            {
                Header: "Recebido",
                accessor: "icon_recebido",
                align: "center",
                natureza: [20]
            }
        ];

        Columns.forEach(item => {
            if ((item.natureza.includes(natureza)) && (_.isUndefined(item.checkPermission) || JSON.parse(ATipos).includes(item.checkPermission))) {
                AResponse.push(item);
            }
        });

        return AResponse;
    };

    getColumns = () => {
        var AResponse = [];
        const { natureza, showRecibo = false } = this.props;
        const Columns = [
            {
                Header: "ID",
                accessor: "idtarefaprocessoapontamento",
                align: "center",
                natureza: [0, 1, 2, 3, 4, 5, 6, 7, 15, 16, 18, 20]
            },
            {
                Header: "Pedido(s)",
                accessor: "parent",
                align: "center",
                natureza: [1, 5]
            },
            {
                Header: "Depósito",
                accessor: "nome",
                align: "center",
                natureza: [2, 3, 15, 16]
            },
            {
                Header: "Nome",
                accessor: "nome",
                align: "center",
                natureza: [4, 5, 6, 18, 20]
            },
            {
                Header: "Fornecedor",
                accessor: "nome",
                align: "center",
                natureza: [0, 1, 7]
            },
            {
                Header: "Valor",
                accessor: "valortotaldescricao",
                align: "center",
                natureza: [0, 1, 2, 3, 4, 5, 6, 7, 18]
            },
            {
                Header: "Status",
                accessor: "status",
                align: "center",
                natureza: [1, 5]
            },
            {
                Header: "Competência",
                accessor: "competenciadescricao",
                align: "center",
                natureza: [0, 4, 20]
            },
            {
                Header: "Validade",
                accessor: "validadedescricao",
                align: "center",
                natureza: [0, 4]
            },
            {
                Header: "Receber",
                accessor: "icon_gerartitulo",
                align: "center",
                natureza: [0, 4]
            },
            {
                Header: "Gerar pedido",
                accessor: "icon_gerarpedido",
                align: "center",
                natureza: [7, 18]
            },
            {
                Header: "Pedido",
                accessor: "icon_imprimir_pedido",
                align: "center",
                natureza: [0, 4]
            },
            {
                Header: "Imprimir",
                accessor: "icon_imprimir_titulo",
                align: "center",
                natureza: [1, 5]
            }
        ];
        if (showRecibo) {
            Columns.push({
                Header: "Recibo",
                accessor: "icon_imprimir_recibo",
                align: "center",
                natureza: [0, 4]
            });
        }
        Columns.forEach(item => {
            if (item.natureza.includes(natureza)) {
                AResponse.push(item);
            }
        });
        return AResponse;
    };

    getIconHeader = (_AColumn, _AValue) => {
        if (_AValue.statusregistro === 0) {
            return (
                <XAPPButton
                    type="Icon"
                    className="h-32 w-32 p-6 noHover"
                    variant="contained"
                    color="primary"
                    onClick={() => { }}
                    iconProps={"justify-center text-red"}
                    icon={"close"}
                />
            );
        }
        else {
            switch (_AColumn.accessor) {
                case "icon_gerartitulo": {
                    if (_.filter(_AValue.itens, { statusregistro: 1 }).length < 1) {
                        return (
                            <XAPPButton
                                type="Icon"
                                className="h-32 w-32 p-6 noHover"
                                variant="contained"
                                color="primary"
                                onClick={() => { }}
                                iconProps={"justify-center text-red"}
                                icon={"warning"}
                            />
                        );
                    }
                    else if (!_.isNull(_AValue.valorpendente)) {
                        if (_AValue.valorpendente < 1) {
                            return (<div />);
                        }
                        return (
                            <XAPPButton
                                type="Icon"
                                className="h-32 w-32 p-6"
                                variant="contained"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    this.props.openNovoDialog({
                                        ..._AValue,
                                        natureza: this.props.natureza + 1,
                                        idtarefaprocessoapontamento: null,
                                        idparent: _AValue.idtarefaprocessoapontamento
                                    });
                                }}
                                iconProps={"justify-center text-yellow"}
                                icon={_AValue.valorpendente !== _AValue.valortotal ? "warning" : "cifrao"}
                            />
                        );
                    }
                    else {
                        return (
                            <XAPPButton
                                type="Icon"
                                className="h-32 w-32 p-6 noHover"
                                variant="contained"
                                color="primary"
                                onClick={() => { }}
                                iconProps={"justify-center text-green"}
                                icon={"done"}
                            />
                        );
                    }
                }
                case "icon_gerarpedido": {
                    return (
                        <React.Fragment>
                            {(_.isNull(_AValue.idparent) || _AValue.idparent.toString()[0] === "-") &&
                                <XAPPButton
                                    type="Icon"
                                    className="h-32 w-32 p-6"
                                    variant="contained"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.props.gerarPedido(_AValue);
                                    }}
                                    iconProps={"justify-center text-yellow"}
                                    icon={"request"}
                                />
                            }
                        </React.Fragment>
                    );
                }
                case "icon_imprimir_pedido": {
                    return (
                        <React.Fragment>
                            <ImprimirApp
                                type="Icon"
                                xappRouteParams={this.props.xappRouteParams}
                                data={JSON.stringify(this.getDadosImpressao(_AValue))}
                                key="btnImprimir"
                                id="btnImprimir"
                                label={"Pedido"}
                                idrelatorio={Number(this.getDicionario("impressao_pedido", "113"))}
                                className="h-32 w-32 p-6 text-blue"
                            />
                        </React.Fragment>
                    );
                }
                case "icon_imprimir_recibo": {
                    return (
                        <React.Fragment>
                            {_AValue.valorpendente === 0 || _AValue.valorpendente !== _AValue.valortotal &&
                                <XAPPButton
                                    type="Icon"
                                    tooltip={{ "title": "Imprimir recibo", "placement": "top" }}
                                    className="h-32 w-32 p-6"
                                    variant="contained"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.props.openReciboDialog(_AValue.idtarefaprocessoapontamento);
                                    }}
                                    iconProps={"justify-center text-blue"}
                                    icon={"print"}
                                />
                            }
                        </React.Fragment>
                    );
                }
                case "icon_imprimir_titulo": {
                    return (
                        <ImprimirApp
                            type="Icon"
                            xappRouteParams={this.props.xappRouteParams}
                            data={JSON.stringify(this.getDadosImpressao(_AValue))}
                            key="btnImprimir"
                            id="btnImprimir"
                            label={"Recibo"}
                            idrelatorio={109}
                            className="h-32 w-32 p-6 text-blue"
                        />
                    );
                }
                default: return <div />;
            }
        }
    };

    getIconDetalhe = (_AColumn, _AValue) => {
        switch (_AColumn.accessor) {
            case "icon_recebido":
                if (_AValue.hastitulo === 1) {
                    return (
                        <XAPPButton
                            type="Icon"
                            className="h-32 w-32 p-6 noHover"
                            variant="contained"
                            color="primary"
                            onClick={() => { }}
                            iconProps={"justify-center text-green"}
                            icon={"done"}
                        />
                    );
                }
                else {
                    return (
                        <XAPPButton
                            type="Icon"
                            className="h-32 w-32 p-6 noHover"
                            variant="contained"
                            color="primary"
                            onClick={() => { }}
                            iconProps={"justify-center text-grey"}
                            icon={"timer"}
                        />
                    );
                }

            default: return <div />;
        }
    };

    getDadosImpressao = (_AValue) => {
        var AResponse = _AValue;
        const { pessoaformulario, sistemas, xappRouteParams, profissional = null } = this.props;
        if (!_.isUndefined(pessoaformulario) && !_.isNull(pessoaformulario)) {
            Object.keys(pessoaformulario).forEach(key => {
                if (typeof pessoaformulario[key] !== "object") {
                    AResponse["cliente_" + key] = pessoaformulario[key];
                }
            });
        }
        if (!_.isUndefined(sistemas[xappRouteParams.empresa]) && !_.isNull(sistemas[xappRouteParams.empresa]) && !_.isNull(sistemas[xappRouteParams.empresa].dados)) {
            var ADados = sistemas[xappRouteParams.empresa].dados;
            if (!_.isUndefined(ADados) && !_.isNull(ADados)) {
                Object.keys(ADados).forEach(key => {
                    if (typeof ADados[key] !== "object") {
                        AResponse["empresa_" + key] = ADados[key];
                    }
                });
            }
        }

        if (!_.isNull(profissional) && !_.isUndefined(profissional.formulario) && !_.isNull(profissional.formulario)) {
            // IMOVEL ONLY
            AResponse["proprietario_nome"] = profissional.formulario.proprietario;
            AResponse["proprietario_email"] = profissional.formulario["proprietario-email"];
            // IMOVEL ONLY

            AResponse["profissional_nome"] = profissional.nome;
            AResponse["profissional_favorecido"] = profissional.formulario.favorecido;
            AResponse["profissional_dadosbancarios"] = profissional.formulario["dados-bancarios"];
        }
        AResponse["mesano"] = getMesAno(_AValue.competencia);
        AResponse["EMISSAODESCRICAO"] = _AValue.datainsdescricao.split(" ")[0];
        return AResponse;
    };

    render() {
        const { natureza, get, xappRouteParams, classes, setCheckApontamento = null, checkApontamento = null, readOnly = false } = this.props;

        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <Table className="min-w-full" aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow className="h-48">
                                {!_.isNull(setCheckApontamento) && !_.isNull(checkApontamento) &&
                                    <TableCell
                                        key={"CheckboxCol"}
                                        align={"center"}
                                        style={{ padding: "2px 12px 2px 12px" }}
                                    >
                                    </TableCell>
                                }
                                {this.getColumns().map(column => (
                                    <TableCell
                                        key={column.accessor}
                                        align={"center"}
                                        style={{ padding: "2px 12px 2px 12px" }}
                                    >
                                        {column.Header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {_.orderBy(this.getApontamentos(), "competencia", "desc").map((n, x) => {
                                return (
                                    <React.Fragment key={x}>
                                        <TableRow className={clsx(n.statusregistro === 1 && !readOnly && "cursor-pointer", classes.bgLineHeader)} >
                                            {!_.isNull(setCheckApontamento) && !_.isNull(checkApontamento) &&
                                                <TableCell
                                                    key={"CheckboxCol"}
                                                    align={"center"}
                                                    style={{ "padding": "2px 12px 2px 12px", "width": "20px" }}
                                                >
                                                    {!_.isNull(n.valorpendente) &&
                                                        <Checkbox
                                                            checked={checkApontamento.includes(n.idtarefaprocessoapontamento)}
                                                            color="primary"
                                                            className={"p-6"}
                                                            onClick={() => setCheckApontamento([n.idtarefaprocessoapontamento], "item")}
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {this.getColumns().map((column, y) => (
                                                <TableCell
                                                    key={y}
                                                    component="th"
                                                    scope="row"
                                                    className={classes.colorHeader}
                                                    align={column.align}
                                                    style={{ padding: "2px 12px 2px 12px", fontWeight: "bold" }}
                                                    onClick={() => { !readOnly && !column.accessor.includes("icon_") && n.statusregistro === 1 && get("SELECIONAR", xappRouteParams, n.idtarefaprocessoapontamento); }}
                                                >
                                                    {column.accessor.includes("icon_") ? (
                                                        n.itens !== null && n.itens.length > 0 &&
                                                        this.getIconHeader(column, n)
                                                    ) : (
                                                        n[column.accessor]
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                        {[3, 4, 7, 18, 20].includes(natureza) && n.itens !== null && n.itens.length > 0 &&
                                            <TableRow className={clsx("h-32", classes.bgLineDetails)}>
                                                <TableCell colSpan={this.getColumns().length + (!_.isNull(setCheckApontamento) && !_.isNull(checkApontamento) ? 1 : 0)}>
                                                    <Table className={"min-w-full"} aria-labelledby="tableTitle">
                                                        <TableHead>
                                                            <TableRow className="h-32">
                                                                {this.getColumnsItens().map(column => (
                                                                    <TableCell
                                                                        key={column.accessor}
                                                                        align={"center"}
                                                                        style={{ padding: "2px 12px 2px 12px", fontWeight: "bold" }}
                                                                    >
                                                                        {column.Header}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {_.sortBy(n.itens, [x => -x.statusregistro]).map((m, z) => (
                                                                <TableRow key={z} className={clsx("h-32", m.statusregistro === 0 && "line-through")}>
                                                                    {this.getColumnsItens().map((column, q) => (
                                                                        <TableCell
                                                                            key={q}
                                                                            className={clsx(classes.noBorder, column.className)}
                                                                            component="th"
                                                                            scope="row"
                                                                            align={column.align}
                                                                            style={{ padding: "2px 12px 2px 12px" }}
                                                                        >
                                                                            {column.accessor.includes("icon_") ? (
                                                                                this.getIconDetalhe(column, m, n)
                                                                            ) : (
                                                                                <React.Fragment>
                                                                                    {m[column.accessor]}
                                                                                </React.Fragment>
                                                                            )}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </FuseAnimate>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        openReciboDialog: Actions.openReciboDialog,
        acaoRegistroItem: Actions.acaoRegistroItem,
        openNovoDialog: Actions.openNovoDialog,
        showMessage: AppActions.showMessage,
        saveItem: Actions.saveItem,
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        sistemas: auth.user.data.settings.sistemas,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoList)));
